import React, { Component } from 'react';
import {connect} from 'react-redux';
import {CSVLink} from 'react-csv';
import Modal from 'react-responsive-modal';
import DocumentItem from './DocumentItem';
import DocumentItemV2 from './DocumentItemV2';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { FeatureFlagEnum } from '../../utils/enums';
import { sanitizeCsvData } from '../../utils/csvSanitizer';


const log = new Logger('PROCESSED_DOCUMENTS_EXPORT_PANEL', LOG_LEVELS.DEBUG);

export class ErrorsAndWarningsExportPanel extends Component {

  constructor(props) {
    super(props);
    const enableCompanyCodeProcessedDocumentsGrid = this.props.featureFlags?.[FeatureFlagEnum.ENABLE_COMPANYCODE_PROCESSED_DOCUMENTS_GRID];
    this.HEADERS = [
      { "key": "fileName", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_FileName') },
      { "key": "processingDate", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_DateProcessed') },
      ...(enableCompanyCodeProcessedDocumentsGrid ? [
        { "key": "userCode", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_companyCode') }
      ] : []),
      {
        "key": "userName", "label": LANGUAGES_CONTROLLER.format(
          props.languages,
          enableCompanyCodeProcessedDocumentsGrid
            ? 'processedDocumentsExportPanel_companyName'
            : 'processedDocumentsExportPanel_company'
        )
      },
      { "key": "processedCount", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_processed') },
      { "key": "errorCount", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_error') },
      { "key": "onholdCount", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_OnHold') },
      { "key": "inboxCount", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_Pending') },
      { "key": "totalCount", "label": LANGUAGES_CONTROLLER.format(props.languages, 'processedDocumentsExportPanel_TotalNumber') }
    ];
  }

  render() {
    log.debug('render: ', this.props);
    const totalCountGenerator = (entry) => { 
      const totalCount = entry.processedCount + entry.errorCount + entry.onholdCount;
      const userName = entry.userName ? entry.userName: 'Unknown company id: '+entry.userId;
      let processingDate = entry.processingDate;
      if (processingDate === null) {
        processingDate = LANGUAGES_CONTROLLER.format(this.props.languages, 'Processing');
      }
      else if (typeof processingDate !== 'string') {
        processingDate = LANGUAGES_CONTROLLER.format(this.props.languages, 'Unknown');
      } 
      else {
        processingDate = processingDate.substr(0, 10);
      }
      return Object.assign({}, entry, {totalCount: totalCount, userName: userName, processingDate: processingDate});
    };
    const exportListWithTotalCount = (this.props.list && this.props.list.map(totalCountGenerator)) || [];
    const fileNameWithExt = `${this.props.filename}.csv`;

    const MODAL_CLASSNAMES =  {
      modal: 'modal-full-width-height modal-max-width-85 pb0'
    };
    const enableNewProcessedDocumentGrid = this.props.featureFlags?.[FeatureFlagEnum.ENABLE_NEW_PROCESSED_DOCUMENT_GRID];
    return (
      <div>
        <Modal 
          classNames={MODAL_CLASSNAMES}
          open={true}
          onClose={this.props.onDone}
        >
          <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'documentDetails_Header')}</h2>
          <table id={'export-documents-table'}>
            <thead>
              {enableNewProcessedDocumentGrid ? (
                <DocumentItemV2
                  header={true}
                  forExport={true}
                />
              ) : (
                <DocumentItem
                  header={true}
                  forExport={true}
                />
              )}
            </thead>
            <tbody>
              {((documentList) => {
                if (!Array.isArray(documentList) || documentList.length <= 0) {
                  return enableNewProcessedDocumentGrid ? (
                    <DocumentItemV2 none={true} forExport={true}/>
                  ) : (
                    <DocumentItem none={true} forExport={true}/>
                  );
                }
                
                return documentList.map((document, index) => {
                  return enableNewProcessedDocumentGrid ? (
                    <DocumentItemV2 key={index} document={document} forExport={true}/>
                  ) : (
                    <DocumentItem key={index} document={document} forExport={true}/>
                  );
                });
              })(this.props.list)}
            </tbody>
          </table>
          <CSVLink
            data={sanitizeCsvData(exportListWithTotalCount)}
            filename={fileNameWithExt} 
            headers={this.HEADERS} 
            className="button primary mb20"
          >
            {LANGUAGES_CONTROLLER.format(this.props.languages, 'global_SaveAs')+' '}
            {fileNameWithExt}
          </CSVLink>
        </Modal>
      </div>
    )       
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
    featureFlags: state.featureFlag && state.featureFlag.data
  };
}



// Wrap the component to inject state into it
export default connect(mapStateToProps)(ErrorsAndWarningsExportPanel);